/** 过渡时间，默认 0.3 秒 */
export const TRANSITION_DURATION = 0.3
